'use strict';

var _ = require('lodash');
var GridSendServiceButtonController = function GridSendServiceButtonController($scope, $rootScope, scenarioService, reservationSystemService) {
  var gridPanel = $scope.gridPanelScope;
  $scope.isSendButtonShow = false;
  $scope.onRowSelection = function (event, selectedRows) {
    var isScenarioSelected = scenarioService.isScenarioSelected();
    $scope.selectedRows = _.filter(selectedRows, function (row) {
      return row.isDiscontinued === 'No';
    });
    $scope.isSendButtonShow = _.size($scope.selectedRows) > 0 && !isScenarioSelected;
  };
  $scope.sendServices = function () {
    reservationSystemService.sendServices($scope.selectedRows).then(function () {
      $rootScope.$broadcast('grid:clearAndLoadData:' + gridPanel.gridId);
    });
  };
};
GridSendServiceButtonController.$inject = ['$scope', '$rootScope', 'ScenarioService', 'ReservationSystemService'];
module.exports = GridSendServiceButtonController;